(function () {
    'use strict';

    angular
        .module('app.password-reset')
        .constant('passwordResetResolver', {
            data: resolveToken
        });

    resolveToken.$inject = ['PasswordReset', '$transition$'];
    function resolveToken(PasswordReset, $transition$) {
        var token = $transition$.params().token;
        return token ? PasswordReset.resolveToken({ token: token }, true).$promise.catch(error) : error();

        function error() {
            return { token: token, isExpired: true };
        }
    }
})();